export default __webpack_public_path__ + "static/media/24_SchererGruppe-DTM-Documentary-EschweilerPhotography_M1A3066.dc47d87b.jpg";